module.exports = "<template bindable=\"item, cart, allowEdit\"> <td class=text-right>${ item.itemDuration > 0 ? item.itemDuration : '' }</td> </template> ";